/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type PositionEntity, positionSchema } from '@axiom/domain';
import { PositionRole } from '../../../enums/generated/position-role';
import { eSTagDAOSchema } from './es-tag-dao';

export const eSPositionDAOSchema = positionSchema.pick({ "description": true, "endDate": true, "id": true, "name": true, "startDate": true }).extend({ "role": z.nativeEnum(PositionRole).nullish(), "tags": z.array(z.lazy(() => eSTagDAOSchema)) });
export type ESPositionDAO = Pick<PositionEntity, "description" | "endDate" | "id" | "name" | "startDate"> & z.infer<typeof eSPositionDAOSchema>;
